import { nextTick } from 'vue'
import $ from 'jquery'
import { createWebHistory, createRouter } from 'vue-router'
import dashboardV5 from './dashboard-v5'
import settingsV5 from './settings-v5'
import kiosk from './kiosk'
import standalones from './standalones'

export const router = createRouter({
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes: [...settingsV5, ...dashboardV5, ...kiosk, ...standalones],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        // without setTimeout, it will not scroll to the hash
        // the component is not yet rendered when this is called, delay 100ms
        setTimeout(() => {
          resolve({
            selector: to.hash,
            behavior: 'smooth'
          })
        }, 100)
      })
    }

    return { left: 0, top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.length > 0 && typeof to.meta.rolePermission !== 'undefined' && !Spark.roleHasPermission(to.meta.rolePermission)) {
    if (to.meta.alertNoPermission) {
      window.SwalTimer.fire({
        icon: 'error',
        title: 'No permission, please contact your admin.'
      })
      next(false)
    } else {
      location.href = Spark.router('web.pages.no-role-permission')
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  // Re-title only works for matched routes
  if (to.matched.length > 0) {
    nextTick(() => {
      if (to.meta.title) {
        document.title = to.meta.title + ' - ' + import.meta.env.VITE_APP_NAME
      } else {
        document.title = import.meta.env.VITE_APP_NAME
      }

      if (to.meta.bodyClass) {
        $('body').addClass(to.meta.bodyClass)
      }
    })
  }

  if (from && from.meta && from.meta.bodyClass) {
    $('body').removeClass(from.meta.bodyClass)
  }
})

export default router
